// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const NotificationBarContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-notificationbarcontainer" */ "./NotificationBarContainer")).then((bundle)=>{
        return {
            default: bundle.NotificationBarContainer
        };
    });
export const LazyNotificationBarContainer = /*#__PURE__*/ lazy(NotificationBarContainerLazyLoader);
